import React, { Component, PropTypes } from 'react';
import './AvatarForm.css';

class AvatarForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatar: this.props.avatar
    };
  }

  render() {
    let avatarPreviewStyle = null;
    if (this.state.avatar) {
      avatarPreviewStyle = {
        'backgroundImage': `url(${this.state.avatar})`
      };
    }

    let options = [
      <label key="choose-avatar" htmlFor="avatar-file-upload"><button type="button" className="form-button" onClick={this.onClickUpload}>Choose profile photo...</button></label>
    ];

    if (!!this.state.avatar) {
      options = [
        <label key="choose-new-avatar" htmlFor="avatar-file-upload"><button className="form-button" type="button" onClick={this.onClickUpload}>Choose new profile photo...</button></label>,
        <button key="remove-avatar" onClick={this.onClickDelete} className="form-button form-button--destroy" type="button">Remove profile photo</button>
      ];
    }

    return (
      <div className="AvatarForm">
        <input type="file"
          accept="image/png, image/jpeg"
          id="avatar-file-upload"
          onChange={this.onFileChange}
          ref={(input) => { this.fileInput = input }}
          className="AvatarForm__file-input" />

        <div className="AvatarForm__preview" style={avatarPreviewStyle}></div>

        <div className="AvatarForm__controls">
          {options}
        </div>
      </div>
    );
  }

  onFileChange = (event) => {
    const { files } = event.target;
    const file = files[0];

    // If no file was selected, return early.
    if (!file) {
      return;
    }

    console.log('Got avatar:', file);
    let avatarUrl = URL.createObjectURL(file);
    this.setState({ avatar: avatarUrl });

    this.props.onAvatarSelect(file);
  }

  onClickUpload = () => {
    // console.log('Clicked upload!', this.fileInput);
    this.fileInput.click();
  }

  onClickDelete = () => {
    this.fileInput.value = null;
    this.setState({ avatar: null });

    // Pass the `null` avatar up to the onAvatarSelect callback.
    this.props.onAvatarSelect(null);
  }
}

AvatarForm.propTypes = {
  onAvatarSelect: PropTypes.func.isRequired
};

export default AvatarForm;



// WEBPACK FOOTER //
// ./src/components/AvatarForm.js